import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { uniformeModulo } from "src/app/aplicaciones-modulos/spyral/diccionarios/uniformeModule";
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { DataLoginModel } from '../../model/dataLoginModel';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { ClothesService } from "../../services/clothes.service";
import { GroupSizesService } from "../../services/gruopSize.service";
import { ResponseGrupoSizeModel } from "../../model/responseGrupoSizeModel";

@Component({
  selector: 'app-prenda',
  templateUrl: './prenda.component.html',
  styleUrls: ['./prenda.component.css']
})
export class PrendaComponent implements OnInit {

  dataUsuario: DataLoginModel;
  mostrarFormulario: boolean = false;
  resposiveFull: string;
  uniformeModulo: any = {};

  formulario: FormGroup;//formulario

  textoBuscar: string;
  columnDefs: any[];//aggrid
  rowData: ResponseGrupoSizeModel[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;

  listaVacia: boolean = false;
  idGrupoSize: string = "";
  loading:boolean = false;

  constructor(private fb: FormBuilder, private _util: UtilsService,
              private _clothes: ClothesService, private _groupSizes: GroupSizesService) { }

  ngOnInit() {
    this.dataUsuario = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.uniformeModulo = uniformeModulo;
    this.resposiveFull = this.uniformeModulo.div.resposiveFull;

    this.formulario = this.fb.group({
      codBaan: ['',[Validators.required]],
      descrp: ['',[Validators.required]],
      punit: ['',[Validators.required]],
    });

    this.cargarGrid();
    this.getAllGrupoSize();

  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'Codigó Grupo',
        field: 'grupoSz',
        filter: true,
        width: 210,
      },
      {
        headerName: 'Descripcion',
        field: 'descrp',
        filter: true,
        width: 405,
      }
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  setGrupoSize(event){
    this.idGrupoSize = event.data.grupoSz;
  }

  getAllGrupoSize(){
    this._groupSizes.getAllGroupSizes().subscribe((res:ResponseGrupoSizeModel[])=>{
      this.rowData = res;
      if(this.rowData.length > 0){
        this.listaVacia = false;
      } else {
        this.listaVacia = true;
      }
    },(err)=>{
      console.log(err);
      this.listaVacia = true;
      this._util.mensajeErrorVisto(err.error.message);
    });
  }

  buscarPrenda(){
    this._clothes.findClothes(this.formulario.get('codBaan').value).subscribe((res:ResponseGrupoSizeModel)=>{
      this.idGrupoSize = res.grupoSz;
      this._util.mensajeOKToast("La Prenda ya EXISTE en el Sistema CEU. Se actualizarán su datos.");
    },(err)=>{
      console.log(err);
      this.idGrupoSize = "";
      this._util.mensajeErroToast(err.error.message);
    });
  }
  crearClothes(){
    if(this.idGrupoSize == ''){
      this._util.mensajeErrorVisto("Debe seleccionar un codigó de Grupo de Prenda")
    }
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea guardar el siguiente Parametro Inicial?',
        text: '',
        action: 'Guardar',
        funcion: this._clothes.createClothes(this.idGrupoSize, this.formulario.value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      console.log(res);
      this.formulario.reset();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

}
